import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Header.css";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  // Enhanced navigation function that works across pages
  const handleScrollTo = (targetId) => {
    // Close mobile menu first
    const navbarCollapse = document.getElementById('navbarNav');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      const bsCollapse = new window.bootstrap.Collapse(navbarCollapse, {
        toggle: false
      });
      bsCollapse.hide();
    }

    // If we're not on home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      // Wait for navigation then scroll
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    } else {
      // If we're on home page, just scroll
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  return (
    <nav className="header navbar navbar-expand-lg navbar-dark">
      <div className="container-fluid">
        {/* Logo - Left */}
        <Link className="navbar-brand logo" to="/">
          <img src="./assets/logo.png" alt="Rite Soccer Logo" />
        </Link>

        {/* Hamburger (Mobile Only) */}
        <button
          className="navbar-toggler ms-auto"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <img
            src="./assets/hamburger.png"
            alt="Menu"
            style={{ width: "24px", height: "24px" }}
          />
        </button>

        {/* Collapsible Content */}
        <div className="collapse navbar-collapse" id="navbarNav">
          {/* Center Menu */}
          <ul className="navbar-nav mx-auto text-center">
            <li className="nav-item">
              <button 
                className="nav-link btn btn-link"
                onClick={() => handleScrollTo('how-it-works')}
                style={{ border: 'none', background: 'none', padding: '0.5rem 1rem' }}
              >
                Features
              </button>
            </li>
            <li className="nav-item">
              <button 
                className="nav-link btn btn-link"
                onClick={() => handleScrollTo('faq-latest')}
                style={{ border: 'none', background: 'none', padding: '0.5rem 1rem' }}
              >
                FAQs
              </button>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">Contact</Link>
            </li>
          </ul>

          {/* Store Buttons - Right */}
          <div className="d-flex justify-content-center justify-content-lg-end gap-2 flex-wrap header-store-btns">
            <a
              href="https://apps.apple.com/pk/app/ritesoccer/id6754843547"
              target="_blank"
              rel="noopener noreferrer"
              className="header-store-link"
            >
              <div className="header-store-btn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="black">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                <span>App Store</span>
              </div>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.RiteSoccer.RiteSoccer"
              target="_blank"
              rel="noopener noreferrer"
              className="header-store-link"
            >
              <div className="header-store-btn">
                <img src="./assets/playstore.png" alt="Google Play" style={{ width: "18px", height: "18px", objectFit: "contain" }} />
                <span>Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;